import YouTubeVideo from '../classes/YouTubeVideoClass';
import HTMLVideo from '../classes/HTMLVideoClass';
import VimeoVideo from '../classes/VimeoVideoClass';

const selectors = {
    video: '.js-video:not(.is-initialized)',
    player: '.js-video-player'
};

const classes = {
    iframe: ['o-video__player', 'js-video-container']
};

const createVimeoIframe = (video) => {
    const iframeTag = document.createElement('iframe');
    iframeTag.src = `https://player.vimeo.com/video/${video.dataset.id}`;
    iframeTag.setAttribute('frameborder', '0');
    iframeTag.allowFullscreen = true;
    iframeTag.allow = 'autoplay';
    iframeTag.classList.add(...classes.iframe);
    video.appendChild(iframeTag);
    
    video.el = new VimeoVideo(video);
}

const initVimeoVideos = (videos) => {
    videos.forEach(video => {
        createVimeoIframe(video);
    });
}

const createYoutubeIframe = async (video) => {
    const iframeTag = document.createElement('iframe');
    const autoplay = video.dataset.autoplay === 'true' ? 1 : 0;
    const loop = video.dataset.loop === 'true' ? 1 : 0;
    const videoInfo = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${video.dataset.id}&format=json`).then(response => {
        return response.json();
    }).then(data => {
        return {
            width: data.width,
            height: data.height
        };
    }).catch(() => {
        return {
            width: 560,
            height: 315
        };
    });

    const videoRatio = (videoInfo.width / videoInfo.height);
    const containerRatio = video.offsetWidth / video.offsetHeight;
    
    if (containerRatio > videoRatio) {
        iframeTag.style.width = '100%';
        iframeTag.style.height = (video.offsetWidth / videoRatio) + 'px';
    } else {
        iframeTag.style.height = '100%';
        iframeTag.style.width = (video.offsetHeight * videoRatio) + 'px';
    }
    iframeTag.src = `https://www.youtube-nocookie.com/embed/${video.dataset.id}?enablejsapi=1&playsinline=1&mute=1&autoplay=${autoplay}&loop=${loop}${loop ? `&playlist=${video.dataset.id}` : ''}&controls=${autoplay ? 0 : 1}&rel=0&showinfo=0&modestbranding=1`;
    iframeTag.setAttribute('frameborder', '0');
    iframeTag.classList.add(...classes.iframe);
    video.appendChild(iframeTag);
    
    video.el = new YouTubeVideo(video);
}

const initYTVideos = (videos) => {
    const scriptTag = document.createElement('script');
    scriptTag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag.nextSibling);

    if (window.YT) {
        videos.forEach(video => {
            createYoutubeIframe(video);
        });
    } else {
        window.onYouTubeIframeAPIReady = () => {
            videos.forEach(video => {
                createYoutubeIframe(video);
            });
        }
    }
}

const initHTMLVideos = (videos) => {
    videos.forEach(video => {
        const player = video.querySelector(selectors.player);
        if (player.matches('[data-controls="false"]')) return;

        setTimeout(() => {
            video.el = new HTMLVideo(video);
        }, 100);
    });
}

const init = () => {
    const videos = [...document.querySelectorAll(selectors.video)];
    if (!videos.length) return;

    const ytVideos = videos.filter(video => video.dataset.type === 'youtube');
    const vimeoVideos = videos.filter(video => video.dataset.type === 'vimeo');

    document.addEventListener('cookiesUpdated', () => {
        if (window.cookieConsent == 'true') {
            if (ytVideos.length) {
                initYTVideos(ytVideos);
            }
            if (vimeoVideos.length) {
                initVimeoVideos(vimeoVideos);
            }
        }
    });

    const htmlVideos = videos.filter(video => video.dataset.type === 'html');
    if (htmlVideos.length) {
        initHTMLVideos(htmlVideos);
    }

    let observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.8
    };
    
    let observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting && entry.target.el && entry.target.el.player) {
                if (entry.target.el.player.matches('[autoplay]') && !entry.target.el.isPlaying) return;
                entry.target.el.pauseVideo();
            }
    
        });
    }, observerOptions);

    videos.forEach(video => {
        video.classList.add('is-initialized');
        observer.observe(video);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;